// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as BlogRouteRouteImport } from './routes/blog/route'
import { Route as BenchmarksRouteRouteImport } from './routes/_benchmarks/route'
import { Route as ContributingIndexRouteImport } from './routes/contributing/index'
import { Route as HomeIndexRouteImport } from './routes/_home/index'
import { Route as BlogIndexRouteImport } from './routes/blog/index'
import { Route as BlogSlugRouteImport } from './routes/blog/$slug'
import { Route as BenchmarksRuntimeRouteRouteImport } from './routes/_benchmarks/_runtime/route'
import { Route as RepoRawSplatRouteImport } from './routes/repo/raw.$'
import { Route as ApiTweetIdRouteImport } from './routes/api/tweet.$id'
import { Route as BenchmarksStackIndexRouteImport } from './routes/_benchmarks/stack/index'
import { Route as BenchmarksDownloadIndexRouteImport } from './routes/_benchmarks/download/index'
import { Route as BenchmarksRuntimeValidationIndexRouteImport } from './routes/_benchmarks/_runtime/validation/index'
import { Route as BenchmarksRuntimeStringIndexRouteImport } from './routes/_benchmarks/_runtime/string/index'
import { Route as BenchmarksRuntimeStandardIndexRouteImport } from './routes/_benchmarks/_runtime/standard/index'
import { Route as BenchmarksRuntimeParsingIndexRouteImport } from './routes/_benchmarks/_runtime/parsing/index'
import { Route as BenchmarksRuntimeInitializationIndexRouteImport } from './routes/_benchmarks/_runtime/initialization/index'
import { Route as BenchmarksRuntimeCodecIndexRouteImport } from './routes/_benchmarks/_runtime/codec/index'

const BlogRouteRoute = BlogRouteRouteImport.update({
            id: '/blog',path: '/blog',getParentRoute: () => rootRouteImport
          })
const BenchmarksRouteRoute = BenchmarksRouteRouteImport.update({
            id: '/_benchmarks',getParentRoute: () => rootRouteImport
          })
const ContributingIndexRoute = ContributingIndexRouteImport.update({
            id: '/contributing/',path: '/contributing/',getParentRoute: () => rootRouteImport
          })
const HomeIndexRoute = HomeIndexRouteImport.update({
            id: '/_home/',path: '/',getParentRoute: () => rootRouteImport
          })
const BlogIndexRoute = BlogIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => BlogRouteRoute
          })
const BlogSlugRoute = BlogSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => BlogRouteRoute
          })
const BenchmarksRuntimeRouteRoute = BenchmarksRuntimeRouteRouteImport.update({
            id: '/_runtime',getParentRoute: () => BenchmarksRouteRoute
          })
const RepoRawSplatRoute = RepoRawSplatRouteImport.update({
            id: '/repo/raw/$',path: '/repo/raw/$',getParentRoute: () => rootRouteImport
          })
const ApiTweetIdRoute = ApiTweetIdRouteImport.update({
            id: '/api/tweet/$id',path: '/api/tweet/$id',getParentRoute: () => rootRouteImport
          })
const BenchmarksStackIndexRoute = BenchmarksStackIndexRouteImport.update({
            id: '/stack/',path: '/stack/',getParentRoute: () => BenchmarksRouteRoute
          })
const BenchmarksDownloadIndexRoute = BenchmarksDownloadIndexRouteImport.update({
            id: '/download/',path: '/download/',getParentRoute: () => BenchmarksRouteRoute
          })
const BenchmarksRuntimeValidationIndexRoute = BenchmarksRuntimeValidationIndexRouteImport.update({
            id: '/validation/',path: '/validation/',getParentRoute: () => BenchmarksRuntimeRouteRoute
          })
const BenchmarksRuntimeStringIndexRoute = BenchmarksRuntimeStringIndexRouteImport.update({
            id: '/string/',path: '/string/',getParentRoute: () => BenchmarksRuntimeRouteRoute
          })
const BenchmarksRuntimeStandardIndexRoute = BenchmarksRuntimeStandardIndexRouteImport.update({
            id: '/standard/',path: '/standard/',getParentRoute: () => BenchmarksRuntimeRouteRoute
          })
const BenchmarksRuntimeParsingIndexRoute = BenchmarksRuntimeParsingIndexRouteImport.update({
            id: '/parsing/',path: '/parsing/',getParentRoute: () => BenchmarksRuntimeRouteRoute
          })
const BenchmarksRuntimeInitializationIndexRoute = BenchmarksRuntimeInitializationIndexRouteImport.update({
            id: '/initialization/',path: '/initialization/',getParentRoute: () => BenchmarksRuntimeRouteRoute
          })
const BenchmarksRuntimeCodecIndexRoute = BenchmarksRuntimeCodecIndexRouteImport.update({
            id: '/codec/',path: '/codec/',getParentRoute: () => BenchmarksRuntimeRouteRoute
          })





const BenchmarksRuntimeRouteRouteChildren = {
  BenchmarksRuntimeCodecIndexRoute: BenchmarksRuntimeCodecIndexRoute,BenchmarksRuntimeInitializationIndexRoute: BenchmarksRuntimeInitializationIndexRoute,BenchmarksRuntimeParsingIndexRoute: BenchmarksRuntimeParsingIndexRoute,BenchmarksRuntimeStandardIndexRoute: BenchmarksRuntimeStandardIndexRoute,BenchmarksRuntimeStringIndexRoute: BenchmarksRuntimeStringIndexRoute,BenchmarksRuntimeValidationIndexRoute: BenchmarksRuntimeValidationIndexRoute
}

const BenchmarksRuntimeRouteRouteWithChildren = BenchmarksRuntimeRouteRoute._addFileChildren(BenchmarksRuntimeRouteRouteChildren)



const BenchmarksRouteRouteChildren = {
  BenchmarksRuntimeRouteRoute: BenchmarksRuntimeRouteRouteWithChildren,BenchmarksDownloadIndexRoute: BenchmarksDownloadIndexRoute,BenchmarksStackIndexRoute: BenchmarksStackIndexRoute
}

const BenchmarksRouteRouteWithChildren = BenchmarksRouteRoute._addFileChildren(BenchmarksRouteRouteChildren)




const BlogRouteRouteChildren = {
  BlogSlugRoute: BlogSlugRoute,BlogIndexRoute: BlogIndexRoute
}

const BlogRouteRouteWithChildren = BlogRouteRoute._addFileChildren(BlogRouteRouteChildren)

const rootRouteChildren = {
  BenchmarksRouteRoute: BenchmarksRouteRouteWithChildren,BlogRouteRoute: BlogRouteRouteWithChildren,HomeIndexRoute: HomeIndexRoute,ContributingIndexRoute: ContributingIndexRoute,ApiTweetIdRoute: ApiTweetIdRoute,RepoRawSplatRoute: RepoRawSplatRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)